export default "__VITE_ASSET__ea563de1__"